module.exports = "https://web-assets-production.autolist.com/_next/static/images/thoughtful-eda0d7ed2e2461a9f2058bcd515c09b3.jpg";